import OthersView from "./OthersView";

const OthersContainer = () => {
  return <OthersView />;
};

export default OthersContainer;
